import { formatNumberWithDecimals } from '../utils/numberUtils';

export class FixedDecimal extends String {
  private value: number;
  private decimals: number;
  constructor(value: number, decimals = 0) {
    super();
    this.value = Number(value);
    this.decimals = decimals;
  }

  toNumber() {
    return Number(formatNumberWithDecimals(this.value, this.decimals));
  }

  toString() {
    return formatNumberWithDecimals(this.value, this.decimals);
  }

  valueOf() {
    return this.toString();
  }

  [Symbol.toPrimitive](hint: string) {
    return hint === 'string' ? this.toString() : this.toNumber();
  }

  get [Symbol.toStringTag]() {
    return 'Number';
  }
}
